import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import Catalog from 'blocks.app/catalog/catalog'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import { TEACHERS_CATALOG_CONFIG, TEACHERS_CATALOG_TYPE, TeachersSelectedItems } from './InstancesCatalogTeachers-types'

const InstancesCatalogTeachersComponent = () => {
    const [selectedItems, setSelectedItems] = useState<TeachersSelectedItems>([])

    return (
        <Content title={TEACHERS_CATALOG_TYPE}>
            <Catalog
                type={TEACHERS_CATALOG_CONFIG.type}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                fixedHeader={TEACHERS_CATALOG_CONFIG.fixedHeader}
                isExistRightToolbar={TEACHERS_CATALOG_CONFIG.isExistRightToolbar}
                treeView={TEACHERS_CATALOG_CONFIG.treeView}
            />
        </Content>
    )
}

export const InstancesCatalogTeachers = checkAvailableModule('instancesCatalog/teachers')
    ? InstancesCatalogTeachersComponent
    : null
